import React from 'react';
import { Link } from '@tanstack/react-router';
import { ChevronRightIcon } from '@heroicons/react/20/solid'; // Use smaller icon

const Breadcrumbs = ({ crumbs }) => {
    if (!crumbs || crumbs.length === 0) {
        return null;
    }

    return (
        <nav className="flex mb-5" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-2">
                {crumbs.map((crumb, index) => (
                    <li key={crumb.label}>
                        <div className="flex items-center">
                            {index !== 0 && (
                                <ChevronRightIcon className="h-4 w-4 flex-shrink-0 text-muted mx-1" aria-hidden="true" />
                            )}
                            {crumb.to ? (
                                <Link 
                                    to={crumb.to}
                                    search={crumb.search || {}} // Pass search params if provided
                                    className="text-sm font-medium text-accent hover:text-accent/90"
                                    aria-current={index === crumbs.length - 1 ? 'page' : undefined}
                                >
                                    {crumb.label}
                                </Link>
                            ) : (
                                <span 
                                    className="text-sm font-medium text-muted-foreground"
                                    aria-current={index === crumbs.length - 1 ? 'page' : undefined}
                                >
                                    {crumb.label}
                                </span>
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumbs; 